export enum statusOptions {
  info = "info",
  system = "system",
  loading = "loading",
  warning = "warning",
  danger = "danger",
  success = "success",
}
